import { readSetting, readUrlSetting, writeSetting } from "../audio/audioEngine";

// Het seintje voor een verkoop: de toeter, dan de omroeper, dan de epische aanloop
// (sale-charge, aanloop.wav). Gedeeld door beeld (AnimationLayer.js), geluid
// (audio/cues.js) en de tijdlijn (hooks/useSaleEvents.js).

// De stoten van public/sounds/toeter.mp3, [begin, eind] in ms na de skip uit samples.js:
// tuu, vier keer tu, en een lange tuuuu. Uitgemeten waar het volume even wegzakt; een
// ander bestand erin betekent deze tijden opnieuw meten, anders blaast het beeld ernaast.
export const hornBlasts = [
  [0, 296],
  [296, 466],
  [466, 642],
  [642, 824],
  [824, 982],
  [982, 2450],
];

export const hornMs = hornBlasts[hornBlasts.length - 1][1];

// De omroeper (public/sounds/omroeper.wav, gemaakt door tools/omroeper.py): "Attentie!"
// en dan "We hebben een nieuwe verkoop!", met muziek eronder die na de zin nog even
// doorzwelt, zodat iedereen kan kijken. Hij begint als de lange tuuuu uit is; de tweede
// regel komt in beeld als hij hem uitspreekt, op het eind van de zin valt een slag. Het
// script drukt deze drie tijden af als je een nieuwe opname erdoor haalt.
export const voiceAt = 2500;
export const voiceLineMs = 1313;
export const voiceEndMs = 3473;
export const voiceMs = 5000;

// Het seintje duurt tot het bestand van de omroeper afbreekt: dan begint de aanloop.
export const glowMs = voiceAt + voiceMs;

// Of het oude seintje: alleen de rand en een klokje, zonder toeters of omroeper.
export const plainGlowMs = 5000;

// Film of oud, per scherm: kiezen in het animatielab of met ?seintje=oud. Film is alles
// als in een trailer (toeter, stem, epische aanloop en records), oud is zoals het was.
export const alertStyles = [
  { id: "film", name: "Film", note: "toeter, stem, trailermuziek, ook bij records" },
  { id: "oud", name: "Oud", note: "zoals het was: de rand, een klokje, de oude records" },
];

const alertKey = "tdAlert";
const alertIds = alertStyles.map((style) => style.id);
let alertChosen = null;

export function alertStyle() {
  if (alertChosen) return alertChosen;
  const saved = readUrlSetting("seintje", alertIds, alertKey) || readSetting(alertKey);
  alertChosen = alertIds.includes(saved) ? saved : alertIds[0];
  return alertChosen;
}

export function setAlertStyle(id, { remember = true } = {}) {
  if (!alertIds.includes(id)) return;
  alertChosen = id;
  if (remember) writeSetting(alertKey, id);
}

export const isPlainAlert = () => alertStyle() === "oud";

// Hoe lang het seintje nu duurt; de aanloop begint daarna.
export const currentGlowMs = () => (isPlainAlert() ? plainGlowMs : glowMs);
